import i18n from '../../../base-dictionary';

enum TaskSortBy {
  CREATED_DATE = 'created_date',
  POINTS = 'points',
  TYPE = 'type',
}

const TASK_SORT_BY_OPTIONS = [
  { label: `${i18n.t('common.created')} Date`, value: TaskSortBy.CREATED_DATE },
  { label: i18n.t('common.estimation'), value: TaskSortBy.POINTS },
  { label: i18n.t('common.type'), value: TaskSortBy.TYPE },
];

export { TASK_SORT_BY_OPTIONS, TaskSortBy };
